import type {AxiosRequestConfig} from 'axios';
import {} from './interface';

export class GetSkusInventoryRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/skus/inventory',
    params: {},
  };

  id(id: number) {
    this.warehouseRequest.url = `/skus/${id}/inventory`;
    return this;
  }
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class GetSkusInventorySumRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/skus/inventory/sum',
    params: {},
  };

  id(id: number) {
    this.warehouseRequest.url = `/skus/${id}/inventory/sum`;
    return this;
  }
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class GetInventoryFlowRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'GET',
    url: '/skus/inventory-flow',
    params: {},
  };

  id(id: number) {
    this.request.url = `/skus/${id}/inventory-flow`;
    return this;
  }
  params(params: object) {
    this.request.params = params;
    return this;
  }

  build() {
    return this.request;
  }
}
export class GetSkuInventoryFlowRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };

  id(id: number) {
    this.request.url = `/products/${id}/inventory-flow`;
    return this;
  }
  params(params: object) {
    this.request.params = params;
    return this;
  }

  build() {
    return this.request;
  }
}
